/**
 * ⚠️ 이 파일은 자동 생성됩니다. 직접 수정하지 마세요!
 * 원본: shared/terms/index.js
 * 동기화: npm run sync:terms (빌드/시작 시 자동 실행)
 */

const TERMS_OF_SERVICE = `
MoneyMind 서비스 이용약관

제1조 (목적)
본 이용약관은 MoneyMind(이하 "회사")가 제공하는 "MoneyMind" 모바일 애플리케이션 및 웹 서비스(이하 총칭하여 "서비스")의 이용조건과 운영에 관한 제반사항 규정을 목적으로 합니다.

제2조 (용어의 정의)
이 약관에서 사용되는 주요한 용어의 정의는 다음과 같습니다.
1. "이용자"란 이 약관에 따라 이용계약을 체결하고, 회사가 제공하는 서비스를 이용하는 자를 말합니다.
2. "이용계약"이란 서비스 이용과 관련하여 회사와 이용자 간에 체결하는 계약을 말합니다.
3. "계정"이란 이용자의 식별과 서비스 이용을 위하여 이용자가 설정하고 회사가 승인한 이메일 주소를 말합니다.
4. "비밀번호"란 이용자가 부여받은 계정과 일치된 이용자임을 확인하고 이용자의 권익 및 비밀을 보호하기 위하여 이용자가 선정한 문자와 숫자의 조합을 말합니다.
5. "거래 데이터"란 이용자가 서비스를 통해 입력하거나 모바일 기기의 알림을 통해 수집된 수입, 지출 등 가계부 내역을 말합니다. 회사는 금융기관으로부터 이용자의 개인신용정보를 제공받지 않으며, 본 서비스의 거래 데이터는 이용자의 개인적인 가계부 기록입니다.
6. "AI 분석 서비스"란 AWS Bedrock을 활용하여 이용자의 거래 데이터를 분석하고 소비 패턴 및 재정 조언을 제공하는 자동화된 서비스를 말합니다.

제3조 (약관의 효력 및 변경)
① 회사는 이 약관의 내용을 서비스 화면에 게재하거나 기타 방법으로 이용자에게 공지하고, 이용자가 동의함으로써 효력이 발생합니다.
② 회사는 필요한 경우 관계 법령을 위반하지 않는 범위에서 이 약관을 변경할 수 있으며, 약관 변경 시에는 적용일자 및 개정사유를 명시하여 현행약관과 함께 그 적용일자 7일 전부터 서비스 내 공지사항을 통해 공지합니다.
③ 중요한 약관 변경의 경우 30일 전에 공지하며, 이용자에게 불리한 변경의 경우 이메일 등을 통해 개별 통지합니다.

제4조 (개인정보처리방침)
이용자의 개인정보보호에 관하여 관련 법령 및 회사가 공지한 개인정보처리방침에 정한 바에 따릅니다.

제5조 (서비스 이용계약 체결)
① 서비스 이용계약은 이용자가 되고자 하는 자가 이 약관의 내용에 대하여 동의를 표시함으로써 서비스 이용 신청을 하고, 회사가 그 신청에 대해서 승낙함으로써 체결됩니다.
② 회사는 다음 각 호의 경우 이용신청을 거절하거나 이용승낙을 취소할 수 있습니다.
  1. 실명이 아니거나 타인의 명의 또는 정보를 이용한 경우
  2. 만 14세 미만 아동인 경우
  3. 이용신청서 내용을 허위로 기재한 경우
  4. 사회의 안녕질서 또는 미풍양속을 저해할 목적으로 신청한 경우
  5. 기타 회사가 정한 이용신청 요건이 미비한 경우
③ 본 서비스는 만 14세 이상 이용자를 대상으로 하며, 만 14세 미만 아동의 가입을 제한합니다.
④ 회사는 만 14세 미만 아동의 회원 가입을 원칙적으로 금지하며, 아동의 개인정보를 의도적으로 수집하지 않습니다. 만약 만 14세 미만 아동의 개인정보가 수집된 사실을 인지하는 경우, 해당 정보를 지체 없이 파기하겠습니다.

제6조 (회사의 의무)
① 회사는 관련 법령 및 이 약관에서 정하는 의무를 신의에 따라 성실하게 준수합니다.
② 회사는 계속적이고 안정적인 서비스의 제공을 위하여 최선의 노력을 다합니다.
③ 회사는 이용자의 개인정보 보호를 위해 보안시스템을 구축하며 개인정보처리방침을 공시하고 준수합니다.
④ 회사는 서비스 이용과 관련하여 이용자로부터 제기된 의견이나 불만이 정당하다고 인정할 경우 이를 처리하여야 합니다.

제7조 (이용자의 의무)
① 이용자는 이 약관을 준수하여야 하며, 다음 각 호의 행위를 하여서는 안 됩니다.
  1. 허위정보 또는 타인의 정보를 사용하는 행위
  2. 타인의 개인정보를 무단으로 수집·저장·게시·유포하는 행위
  3. 회사 및 제3자의 저작권 등 지적재산권을 침해하는 행위
  4. 회사의 서비스를 이용하여 얻은 정보를 무단으로 복제·유통·조장하거나 상업적으로 이용하는 행위
  5. 관련 법령에 위반되거나 선량한 풍속 기타 사회통념에 반하는 행위
② 이용자는 자신의 계정 및 비밀번호를 제3자에게 이용하게 해서는 안 되며, 관리 소홀로 인한 책임은 이용자에게 있습니다.

제8조 (서비스의 제공 및 변경)
① 회사는 다음과 같은 서비스를 제공합니다.
  1. 수입 및 지출 관리 서비스
  2. 예산 설정 및 관리 서비스
  3. AI 기반 소비 패턴 분석 및 재정 조언 서비스
  4. 고정 거래 자동 등록 서비스
  5. 푸시 알림 서비스
  6. 기타 회사가 추가 개발하거나 제휴계약 등을 통해 제공하는 서비스
② 서비스 이용시간은 업무상 또는 기술상 특별한 지장이 없는 한 연중무휴 1일 24시간을 원칙으로 합니다.
③ 회사는 시스템 점검, 증설, 교체, 보수 등의 경우 사전 공지 후 서비스를 일시적으로 중단할 수 있습니다.
④ 회사는 서비스의 내용, 품질, 기능 등을 변경할 수 있으며, 중요한 변경사항은 사전에 공지합니다.

제9조 (AI 분석 서비스)
① 회사는 AWS Bedrock을 활용한 AI 분석 서비스를 제공합니다.
② AI 분석 시 개인 식별 정보는 제거되며, 거래 패턴 분석에 필요한 최소한의 정보만 사용됩니다.
③ AI 분석 결과는 참고용이며, 이용자의 재정 결정에 대한 최종 책임은 이용자에게 있습니다.
④ 이용자는 AI(AWS Bedrock)를 이용한 자동화된 분석 결과에 대해 설명 요구 및 이의제기를 할 수 있습니다. 단, 회사는 AI 분석의 완벽한 정확성을 보장하지 않으며, 분석 결과로 인한 손해에 대해 고의 또는 중과실이 없는 한 책임을 지지 않습니다.

제10조 (알림 스크래핑 서비스 - Android)
① 회사는 Android OS가 제공하는 공식 Notification Listener API를 통해서만 이용자의 동의 하에 알림을 수집하며, 금융회사의 서버에 직접 접근하거나 무단으로 데이터를 수집하지 않습니다.
② 이용자는 언제든지 알림 접근 권한을 철회할 수 있으며, 권한 철회 시에도 서비스의 다른 기능은 정상적으로 이용 가능합니다.
③ 수집된 알림 정보는 오직 가계부 작성을 위한 거래 등록 목적으로만 사용되며, 제3자에게 제공되지 않습니다.

제11조 (데이터 백업 및 손실)
① 회사는 이용자의 거래 데이터를 안전하게 보관하기 위해 정기적으로 백업합니다.
② 이용자는 중요한 데이터를 별도로 백업할 책임이 있으며, 회사는 천재지변, 시스템 장애 등 불가항력적 사유로 인한 데이터 손실에 대해 책임을 지지 않습니다.
③ 회원 탈퇴 시 모든 거래 데이터는 즉시 삭제되며, 복구가 불가능합니다.

제12조 (서비스 이용 해지 및 탈퇴)
① 이용자는 언제든지 서비스 이용을 원하지 않는 경우 회원 탈퇴를 통해 이용계약을 해지할 수 있습니다.
② 회원 탈퇴 시 이용자의 모든 데이터는 개인정보처리방침에 따라 처리됩니다.
③ 회사는 이용자가 다음 각 호에 해당하는 경우 사전 통지 후 이용계약을 해지하거나 서비스 이용을 제한할 수 있습니다.
  1. 타인의 정보를 도용한 경우
  2. 서비스 운영을 고의로 방해한 경우
  3. 관련 법령 또는 이 약관을 위반한 경우

제13조 (저작권)
① 회사가 제작한 콘텐츠에 대한 저작권과 기타 지적재산권은 회사에 귀속합니다.
② 이용자는 회사가 제공하는 서비스를 이용하여 얻은 정보를 회사의 사전 동의 없이 상업적 용도로 이용하여서는 안 됩니다.
③ 이용자가 서비스 내에 게시한 게시물의 저작권은 이용자에게 귀속되나, 회사는 서비스 운영을 위해 이를 사용할 수 있습니다.

제14조 (면책)
① 회사는 천재지변 또는 이에 준하는 불가항력으로 인하여 서비스를 제공할 수 없는 경우에는 서비스 제공에 관하여 책임을 지지 않습니다.
② 회사는 이용자의 고의 또는 과실로 인한 서비스 이용의 장애에 대하여는 책임을 지지 않습니다.
③ 회사는 무료로 제공되는 서비스 이용과 관련하여 이용자에게 발생한 손해에 대해서는 책임을 지지 않습니다. 그러나 회사의 고의 또는 중과실에 의한 경우에는 그러하지 않습니다.
④ 회사는 이용자가 서비스를 이용하여 기대하는 수익을 얻지 못하거나 상실한 것에 대하여 책임을 지지 않습니다.
⑤ 회사는 관련 법령에 따라 이용자 데이터를 서비스 내 노출, 서비스 홍보를 위한 활용, 서비스 운영, 개선 및 새로운 서비스 개발을 위한 연구, 법률상 의무 준수, 이용자의 동의에 따른 외부 사이트에 대한 노출을 위해서만 제한적으로 사용합니다. 단, 이용자의 별도 동의가 있는 경우 그에 따릅니다.
⑥ 회사가 수집한 데이터를 가공하여 생성한 비식별 통계 정보 등 2차적 산출물의 권리는 회사에 귀속됩니다. 단, 해당 데이터는 개인을 식별할 수 없도록 완전히 비식별화된 정보에 한하며, 이용자의 개인정보 또는 거래 내역을 재식별하거나 외부 제공·판매 목적으로 사용하지 않습니다.

제15조 (분쟁 해결)
① 회사는 이용자가 제기하는 정당한 의견이나 불만을 반영하고 그 피해를 보상처리하기 위하여 피해보상처리기구를 설치·운영합니다.
② 회사와 이용자 간에 발생한 분쟁은 전자문서 및 전자거래 기본법에 의하여 설치된 전자문서·전자거래분쟁조정위원회의 조정에 따를 수 있습니다.

제16조 (재판권 및 준거법)
① 이 약관은 대한민국 법률에 따라 규율되고 해석됩니다.
② 회사와 이용자 간 발생한 분쟁에 관한 소송은 민사소송법상의 관할법원에 제소합니다.

부칙
이 약관은 2026년 1월 10일부터 시행합니다.
`;

const PERSONAL_INFO_AGREEMENT = `
MoneyMind 개인정보 처리방침

MoneyMind(이하 "회사")는 이용자의 개인정보를 중요시하며, 「개인정보 보호법」, 「정보통신망 이용촉진 및 정보보호 등에 관한 법률」 등 관련 법령을 준수하고 있습니다.

제1조 (개인정보의 수집 및 이용 목적)
회사는 다음의 목적을 위하여 개인정보를 처리합니다.
1. 회원 가입 및 관리
  - 회원 가입 의사 확인, 회원제 서비스 제공, 본인 확인
  - 이메일 인증, 회원 탈퇴 의사 확인
2. 서비스 제공
  - 거래 내역 관리, 예산 관리, AI 분석 서비스 제공
  - 고정 거래 자동 등록, 푸시 알림 발송
  - 맞춤형 서비스 제공, 서비스 이용 통계 분석
3. 고객 문의 및 불만 처리
  - 민원 처리, 공지사항 전달

제2조 (수집하는 개인정보의 항목)
① 회사는 회원가입, 서비스 이용 등을 위해 아래와 같은 개인정보를 수집하고 있습니다.

[중요] 회사는 금융기관으로부터 이용자의 개인신용정보를 제공받지 않으며, 본 서비스에서 처리하는 거래 내역은 이용자가 직접 입력하거나 이용자의 단말기 알림을 기반으로 생성된 '개인 가계부 기록'입니다. 회사는 이용자의 권리 보호를 위해 해당 정보를 강화된 보호조치로 안전하게 관리합니다.

1. 필수 수집 항목
  - 이메일 주소 (계정 식별 및 인증)
  - 닉네임 (서비스 내 표시명)
  - 비밀번호 (암호화하여 저장)

2. 선택 수집 항목
  - 생년월일, 성별 (맞춤형 서비스 제공)
  - 푸시 알림 토큰 (알림 발송, 회원 탈퇴 시까지 보유)

3. 서비스 이용 과정에서 자동 수집되는 항목
  - 거래 내역 (수입/지출 금액, 카테고리, 날짜, 메모)
  - 예산 설정 및 금융 목표 정보 (목표 금액, 기간 등)
  - 서비스 이용 기록, 접속 로그, IP 주소
  - 기기 정보 (OS 버전, 앱 버전)

4. Android 알림 스크래핑 기능 이용 시 (선택)
  - 금융 앱 알림 내용 (거래 금액, 가맹점명, 거래 시간)
  - 알림 히스토리 (읽은 알림 30일, 안 읽은 알림 90일 보관)
  - 알림 발신 앱 패키지명

② 회사는 만 14세 미만 아동의 회원 가입을 원칙적으로 금지하며, 아동의 개인정보를 의도적으로 수집하지 않습니다. 만약 만 14세 미만 아동의 개인정보가 수집된 사실을 인지하는 경우, 해당 정보를 지체 없이 파기하겠습니다.

제3조 (개인정보의 보유 및 이용기간)
① 회사는 이용자의 개인정보를 다음과 같이 보유 및 이용합니다.

1. 회원 정보
  - 보유기간: 회원 탈퇴 시까지
  - 탈퇴 후: 즉시 파기 (단, 아래 법령에 따른 보존 제외)


2. 거래 데이터
  - 보유기간: 회원 탈퇴 시 즉시 파기
  - 파기 방법: 복구 불가능한 방법으로 완전 삭제
  - 참고: 탈퇴 후에는 거래 데이터 복구 및 확인이 불가능합니다.

2-1. 서비스 개선용 통계 데이터
  - 보유기간: 수집 후 180일 (6개월) - 완전 비식별화 처리
  - 파기 방법: 자동화된 시스템에 의해 영구 삭제
  - 조치 사항: 전화번호, 카드번호 등 민감정보 마스킹 처리 후 저장

2-2. 알림 히스토리
  - 읽은 알림: 30일 보관 후 자동 삭제
  - 안 읽은 알림: 90일 보관 후 자동 삭제
  - 목적: 서비스 이용 내역 확인 및 사용자 편의 제공

3. 법령에 따른 보존
  - 계약 또는 청약철회 등에 관한 기록: 5년 (전자상거래법)
  - 소비자 불만 또는 분쟁처리 기록: 3년 (전자상거래법)
  - 접속 로그 기록: 3개월 (통신비밀보호법)

② 개인정보 보유기간이 경과하거나 처리목적이 달성된 경우 지체 없이 파기합니다.

제4조 (개인정보의 제3자 제공)
① 회사는 원칙적으로 이용자의 개인정보를 제3자에게 제공하지 않습니다.

② 다만, 다음의 경우에는 예외로 합니다.
  1. 이용자가 사전에 동의한 경우
  2. 법령의 규정에 의거하거나, 수사 목적으로 법령에 정해진 절차와 방법에 따라 수사기관의 요구가 있는 경우

③ 회사는 이용자의 거래 데이터를 어떠한 경우에도 제3자에게 판매하거나 제공하지 않습니다.
   단, 서비스 품질 향상 및 AI 정확도 개선을 위해 관리 책임자가 '비식별화된' 학습 데이터를 열람할 수 있습니다.

제5조 (개인정보 처리의 위탁)
① 회사는 서비스 제공을 위해 다음과 같이 개인정보 처리 업무를 위탁하고 있습니다.

1. Oracle Cloud Infrastructure (OCI)
  - 위탁 업무: 서버 호스팅, 데이터베이스 관리
  - 보유 기간: 회원 탈퇴 시 또는 위탁 계약 종료 시까지

2. Amazon Web Services, Inc.
  - 위탁 업무: AI 분석(추론) 서비스(Amazon Bedrock) 제공
  - 처리 위치: 대한민국 리전(AWS ap-northeast-2, 서울)에서만 처리됩니다. 회사는 서울 리전의 On-Demand 추론 엔드포인트를 사용하며, 교차 리전 추론(Cross-Region Inference)은 사용하지 않으므로 AI 분석 데이터가 대한민국 리전 외부로 전송되지 않습니다.
  - 국외 접근 가능성: AWS의 서비스 운영, 보안 관제, 장애 대응, 기술 지원 등의 목적에 한해 AWS Inc. 및 관계사/지원 인력이 국외에서 제한적으로 원격 접근할 수 있습니다. (상세 내용은 제5조의2 참조)
  - 보유 및 이용 기간: AI 분석 처리 목적 달성 시까지

② 회사는 위탁 계약 체결 시 개인정보 보호법에 따라 위탁업무 수행목적 외 개인정보 처리금지, 기술적·관리적 보호조치, 재위탁 제한, 수탁자에 대한 관리·감독, 손해배상 등 책임에 관한 사항을 계약서 등 문서에 명시하고 수탁자가 개인정보를 안전하게 처리하는지를 감독하고 있습니다.

제5조의2 (개인정보의 국외 이전)
회사는 서비스 제공을 위해 「개인정보 보호법」 제28조의8 제1항 제2호(이용자와의 계약 이행을 위하여 필요한 경우)에 따라 다음과 같이 개인정보 처리 업무를 국외의 업체에 위탁하고 있습니다. 국외 이전되는 개인정보는 해당 서비스 제공에 필요한 최소한의 정보로 한정되며, 회사는 이용자의 개인정보가 안전하게 보호되도록 관리·감독합니다.

┌─────────────────────────────────────────────────────────┐
│ 1. Expo, Inc. (푸시 알림)                                │
├─────────────────────────────────────────────────────────┤
│ 이전받는 자: Expo, Inc.                                   │
│ 이전 국가: 미국                                           │
│ 이전 목적: 이용자 단말기에 푸시 알림 전달                     │
│ 이전 항목: 푸시 토큰, 알림 제목 및 내용                      │
│ 이전 방법: 푸시 알림 발송 시 네트워크를 통해 자동 전송          │
│ 보유 기간: 알림 발송 완료 즉시 삭제                          │
│ (참고: 푸시 토큰은 회사 서버에서 회원 탈퇴 시까지 보관)         │
├─────────────────────────────────────────────────────────┤
│ 2. Functional Software, Inc. (Sentry - 에러 모니터링)      │
├─────────────────────────────────────────────────────────┤
│ 이전받는 자: Functional Software, Inc. (Sentry)            │
│ 이전 국가: 미국                                           │
│ 이전 목적: 서비스 안정성 확보를 위한 에러 모니터링 및 성능 분석  │
│ 이전 항목: 에러 로그, 스택트레이스, 기기 정보(OS·앱 버전),     │
│           앱 상태 정보 (개인 식별 정보 제외, 민감정보 마스킹)   │
│ 이전 방법: 에러 발생 시 네트워크를 통해 자동 전송              │
│ 보유 기간: 90일 (이후 자동 삭제)                            │
├─────────────────────────────────────────────────────────┤
│ 3. Amazon Web Services, Inc. (AWS - 기술 지원 접근)        │
├─────────────────────────────────────────────────────────┤
│ 이전받는 자: AWS Inc. 및 관계사/지원 인력                    │
│ 접근 국가: 미국 등 (AWS 지원 인력 소재 국가)                 │
│ 접근 목적: 서비스 안정성 확보 및 장애 대응·기술 지원           │
│ 접근 항목: 비식별화된 거래 패턴 데이터 (개인 식별 정보 제외)    │
│ 접근 방법: 장애 대응·기술 지원 필요 시 네트워크를 통한          │
│           제한적 원격 접근                                  │
│ 보유 기간: 별도 저장하지 않음 (보안·장애 대응 로그는           │
│           제한 기간 보관 후 파기)                            │
│ 참고: AI 분석(추론) 데이터 처리는 대한민국 리전(서울)에서만    │
│      수행되며, 국외로 전송되지 않습니다.                      │
└─────────────────────────────────────────────────────────┘

※ 이용자는 위 국외 이전에 대해 개인정보 보호책임자(제10조)에게 문의하거나 이의를 제기할 수 있습니다.

제6조 (개인정보의 안전성 확보 조치)
회사는 개인정보의 안전성 확보를 위해 다음과 같은 조치를 취하고 있습니다.

1. 관리적 조치
  - 개인정보 취급 직원의 최소화 및 교육
  - 개인정보 보호책임자 지정

2. 기술적 조치
  - 개인정보 암호화 (비밀번호, 거래 데이터)
  - 해킹 등에 대비한 보안 프로그램 설치 및 주기적 점검
  - 접근 권한 관리
  - 접속 기록 보관 및 위변조 방지

3. 물리적 조치
  - 전산실, 자료보관실 등의 접근 통제

제7조 (개인정보의 파기)
① 회사는 개인정보 보유기간의 경과, 처리목적 달성 등 개인정보가 불필요하게 되었을 때에는 지체 없이 해당 개인정보를 파기합니다.

② 파기 절차 및 방법
  1. 파기 절차: 불필요한 개인정보는 개인정보 보호책임자의 승인 후 파기
  2. 파기 방법
    - 전자적 파일: 복구 불가능한 방법으로 영구 삭제
    - 종이 문서: 분쇄기로 분쇄하거나 소각

제8조 (이용자의 권리와 행사 방법)
① 이용자는 언제든지 다음 각 호의 권리를 행사할 수 있습니다.
  1. 개인정보 열람 요구
  2. 개인정보 정정 요구
  3. 개인정보 삭제 요구
  4. 개인정보 처리 정지 요구

② 권리 행사는 앱 내 설정 메뉴 또는 개인정보 보호책임자에게 이메일로 요청할 수 있습니다. 회사는 요청을 받은 날로부터 10일 이내에 조치하고 그 결과를 이용자에게 알려드립니다. 정당한 사유로 조치가 지연되는 경우 그 사유와 처리 일정을 통지합니다.

③ 만 14세 미만 아동의 법정대리인은 아동의 개인정보에 대한 열람, 정정, 삭제를 요구할 수 있습니다.

제9조 (개인정보 자동 수집 장치의 설치·운영 및 거부)
① 회사는 이용자의 정보를 저장하고 수시로 불러오는 '쿠키(cookie)'를 사용하지 않습니다. 이용자의 계정 정보는 암호화된 토큰(JWT) 형태로 모바일 기기 또는 브라우저의 로컬 저장소(Local Storage)에 안전하게 저장됩니다.
② 이용자는 기기 설정 또는 브라우저 설정을 통해 데이터 저장을 거부할 수 있으나, 이 경우 로그인이 필요한 서비스 이용에 제한이 있을 수 있습니다.

제10조 (개인정보 보호책임자)
① 회사는 개인정보 처리에 관한 업무를 총괄해서 책임지고, 개인정보 처리와 관련한 정보주체의 불만처리 및 피해구제 등을 위하여 아래와 같이 개인정보 보호책임자를 지정하고 있습니다.

▶ 개인정보 보호책임자
  - 이름: 김주현
  - 이메일: hi5195@naver.com
  - 전화번호: (문의는 이메일로 부탁드립니다)

② 이용자는 회사의 서비스를 이용하면서 발생한 모든 개인정보 보호 관련 문의, 불만처리, 피해구제 등에 관한 사항을 개인정보 보호책임자에게 문의할 수 있습니다.

제11조 (권익침해 구제 방법)
이용자는 개인정보침해로 인한 구제를 받기 위하여 개인정보분쟁조정위원회, 한국인터넷진흥원 개인정보침해신고센터 등에 분쟁해결이나 상담 등을 신청할 수 있습니다.

▶ 개인정보분쟁조정위원회: 1833-6972 (www.kopico.go.kr)
▶ 개인정보침해신고센터: (국번없이) 118 (privacy.kisa.or.kr)
▶ 대검찰청 사이버범죄수사단: (국번없이) 1301 (www.spo.go.kr)
▶ 경찰청 사이버안전국: (국번없이) 182 (cyberbureau.police.go.kr)

제12조 (개인정보 처리방침의 변경)
① 이 개인정보 처리방침은 2026년 1월 10일부터 적용됩니다.

② 개인정보 처리방침이 변경되는 경우 변경 사항을 서비스 내 공지사항을 통해 공지합니다. 이전 개인정보 처리방침은 서비스 내에서 확인할 수 있습니다.

③ 중요한 변경사항이 있는 경우 최소 7일 전에 공지하며, 이용자에게 불리한 변경의 경우 30일 전에 공지하고 이메일로 개별 통지합니다.
`;

const MARKETING_CONSENT = `
마케팅 정보 수신 동의(선택)

회사는 이용자에게 다음과 같은 마케팅 정보를 제공할 수 있습니다.
1. 신규 서비스 및 이벤트 안내
2. 맞춤형 서비스 제공을 위한 정보
3. 프로모션 및 할인 혜택 안내

수신 방법: 이메일, 앱 푸시 알림, SMS

※ 마케팅 정보 수신에 동의하지 않으셔도 서비스 이용에는 제한이 없습니다.
※ 동의 후에도 언제든지 설정에서 수신을 거부하실 수 있습니다.
`;

const UNDER_14_NOTICE = `
만 14세 미만 이용 불가 안내

MoneyMind는 만 14세 이상만 사용 가능합니다.
만 14세 미만 고객 중 사용을 희망하는 고객의 경우, 고객센터를 통해 보호자 동의 및 확인 절차를 확인해주세요.
`;

export { TERMS_OF_SERVICE, PERSONAL_INFO_AGREEMENT, MARKETING_CONSENT, UNDER_14_NOTICE };
